import { getHallAcquisitionContext } from "./hallAcquisition";
import { trackEmEvent } from "./sdk";

const arrivedDocuments = new WeakSet<object>();

/** Called after the hall app mounts; this does not imply business data is ready. */
export const trackKolHallArrivalOnce = (
  sdkReady: boolean,
  documentKey: object | null | undefined = typeof document === "undefined" ? undefined : document,
): boolean => {
  if (!sdkReady || !documentKey || arrivedDocuments.has(documentKey)) {
    return false;
  }

  const context = getHallAcquisitionContext();
  if (!context.landingPageId) {
    return false;
  }

  trackEmEvent("kol_hall_arrival", {
    ...context,
    entryKind: context.entryKind || "browser",
  });
  arrivedDocuments.add(documentKey);
  return true;
};
